import { createSlice } from "@reduxjs/toolkit";
// import { adminAuthEndpoints } from "./authApi";

const initialState = {
  token: localStorage.getItem("token") ? localStorage.getItem("token") : null,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null,
};

const adminSlice = createSlice({
  name: "admin-slice",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      if (!action.payload) return;
      if (action.payload.token)
        localStorage.setItem("token", JSON.stringify(action.payload.token));
      if (action.payload.user)
        localStorage.setItem("user", JSON.stringify(action.payload.user));

      state.user = JSON.parse(localStorage.getItem("user"));
      state.token = JSON.parse(localStorage.getItem("token"));
    },
    clearAuth: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const { setAuth, clearAuth } = adminSlice.actions;
export const adminSliceReducer = adminSlice.reducer;
export const selectAuth = (state) => state.user;
